<template>
  <div>
    <!-- <svg
      :width="width"
      :height="height"
      @click="toggleDetailShare(true)"
      viewBox="0 0 18 19"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    > -->
      <!-- Generator: sketchtool 63.1 (101010) - https://sketch.com -->
      <!-- <title>E74DF7BF-783B-46B7-93FA-8540CEE22958</title> -->
      <!-- <desc>Created with sketchtool.</desc>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g
          id="Spec"
          transform="translate(-815.000000, -649.000000)"
          fill="#94979c"
          fill-rule="nonzero"
        >
          <g id="share" transform="translate(815.000000, 649.143578)">
            <g
              id="shapes"
              transform="translate(9.000000, 9.000000) scale(1, -1) translate(-9.000000, -9.000000) "
            >
              <path
                d="M9,0 C13.9433203,0 18,4.05667969 18,9 C18,13.9433203 13.9433203,18 9,18 C4.05667969,18 0,13.9433203 0,9 C0,4.05667969 4.05667969,0 9,0 Z M11.6367187,3.7265625 C10.4733633,3.7265625 9.52734375,4.67258203 9.52734375,5.8359375 C9.52734375,5.96668359 9.54312891,6.09349219 9.56594531,6.21769922 L9.56594531,6.21769922 L6.94307812,7.68301172 C6.55614844,7.20372656 5.97125391,6.890625 5.30859375,6.890625 C4.14523828,6.890625 3.19921875,7.83664453 3.19921875,9 C3.19921875,10.1633555 4.14523828,11.109375 5.30859375,11.109375 C6.04430859,11.109375 6.69125391,10.7298281 7.06879687,10.1574141 L7.06879687,10.1574141 L9.59312109,11.6659336 C9.55392188,11.8264219 9.52734375,11.9916563 9.52734375,12.1640625 C9.52734375,13.327418 10.4733633,14.2734375 11.6367188,14.2734375 C12.8000742,14.2734375 13.7460938,13.327418 13.7460938,12.1640625 C13.7460938,11.000707 12.8000742,10.0546875 11.6367188,10.0546875 C11.0255625,10.0546875 10.4790234,10.3199063 10.0935,10.7364375 L10.0935,10.7364375 L7.40482031,9.12969141 C7.40960156,9.05245312 7.44250781,8.9994375 7.38210937,8.645625 L7.38210937,8.645625 L10.018582,7.17271875 C10.405793,7.64050781 10.9832695,7.9453125 11.6367187,7.9453125 C12.8000742,7.9453125 13.7460938,6.99929297 13.7460938,5.8359375 C13.7460938,4.67258203 12.8000742,3.7265625 11.6367187,3.7265625 Z M11.6367188,11.109375 C12.2192066,11.109375 12.6914062,11.5815747 12.6914062,12.1640625 C12.6914062,12.7465503 12.2192066,13.21875 11.6367188,13.21875 C11.0542309,13.21875 10.5820312,12.7465503 10.5820312,12.1640625 C10.5820312,11.5815747 11.0542309,11.109375 11.6367188,11.109375 Z M5.30859375,7.9453125 C5.89108157,7.9453125 6.36328125,8.41751218 6.36328125,9 C6.36328125,9.58248782 5.89108157,10.0546875 5.30859375,10.0546875 C4.72610593,10.0546875 4.25390625,9.58248782 4.25390625,9 C4.25390625,8.41751218 4.72610593,7.9453125 5.30859375,7.9453125 Z M11.6367188,4.78125 C12.2192066,4.78125 12.6914062,5.25344968 12.6914062,5.8359375 C12.6914062,6.41842532 12.2192066,6.890625 11.6367188,6.890625 C11.0542309,6.890625 10.5820312,6.41842532 10.5820312,5.8359375 C10.5820312,5.25344968 11.0542309,4.78125 11.6367188,4.78125 Z"
                id="Combined-Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </svg> -->
    <svg
        id="Component_9_1"
        :class="'Component_9_1' + content.objectid"
        data-name="Component 9 – 1"
        xmlns="http://www.w3.org/2000/svg"
        width="27"
        height="27"
        viewBox="0 0 27 27"
       @click="toggleDetailShare(true)"
      >
        <g
          id="Group_92"
          data-name="Group 92"
          transform="translate(-476 404) rotate(180)"
        >
          <g
            id="Path_20"
            data-name="Path 20"
            transform="translate(-503 377)"
           :fill="!toggleContentShare ? '#161616' : '#FECA35'"
          >
            <path
              d="M13.5,0A13.5,13.5,0,1,1,0,13.5,13.5,13.5,0,0,1,13.5,0Z"
              stroke="none"
            />
            <path
              d="M 13.5 1 C 10.16113090515137 1 7.022109985351562 2.300230026245117 4.661169052124023 4.661169052124023 C 2.300230026245117 7.022109985351562 1 10.16113090515137 1 13.5 C 1 16.83887100219727 2.300230026245117 19.97789001464844 4.661169052124023 22.33882904052734 C 7.022109985351562 24.69976997375488 10.16113090515137 26 13.5 26 C 16.83887100219727 26 19.97789001464844 24.69976997375488 22.33882904052734 22.33882904052734 C 24.69976997375488 19.97789001464844 26 16.83887100219727 26 13.5 C 26 10.16113090515137 24.69976997375488 7.022109985351562 22.33882904052734 4.661169052124023 C 19.97789001464844 2.300230026245117 16.83887100219727 1 13.5 1 M 13.5 0 C 20.95584106445312 0 27 6.044160842895508 27 13.5 C 27 20.95584106445312 20.95584106445312 27 13.5 27 C 6.044160842895508 27 0 20.95584106445312 0 13.5 C 0 6.044160842895508 6.044160842895508 0 13.5 0 Z"
              stroke="none"
              fill="#FECA35"
              class="iconouterfill"
            />
          </g>
          <g
            id="share_black_24dp"
            transform="translate(-481.376 398.624) rotate(180)"
          >
            <path
              id="Path_12"
              data-name="Path 12"
              d="M0,0H16.248V16.248H0Z"
              fill="none"
            />
            <path
              id="Path_13"
              :class="'Path_13' + content.objectid"
              data-name="Path 13"
              d="M13.155,11.532a1.971,1.971,0,0,0-1.327.521L7,9.244a2.216,2.216,0,0,0,.061-.474A2.216,2.216,0,0,0,7,8.3l4.773-2.782a2.026,2.026,0,1,0-.65-1.483,2.216,2.216,0,0,0,.061.474L6.412,7.287a2.031,2.031,0,1,0,0,2.965l4.82,2.816a1.91,1.91,0,0,0-.054.44,1.977,1.977,0,1,0,1.977-1.977Zm0-8.178a.677.677,0,1,1-.677.677A.679.679,0,0,1,13.155,3.354ZM5.031,9.447a.677.677,0,1,1,.677-.677A.679.679,0,0,1,5.031,9.447ZM13.155,14.2a.677.677,0,1,1,.677-.677A.679.679,0,0,1,13.155,14.2Z"
              transform="translate(-0.969 -0.646)"
              fill="#ffffff"
            />
          </g>
        </g>
      </svg>
  </div>
</template>

<script>
import { eventBus } from "@/eventBus";

export default {
  props: {
    content: {
      type: Object
    },
    width: {
      type: String
    },
    height: {
      type: String
    }
  },
  data() {
    return {
      toggleContentShare: false,
      shareContent: null,
    };
  },
  mounted(){
     try {
        document.getElementsByClassName(`Component_9_1${this.content.objectid}`)[0].addEventListener("mouseover", () => {
          document.getElementsByClassName(`Path_13${this.content.objectid}`)[0].setAttribute("fill", "white")
        });

        document.getElementsByClassName(`Component_9_1${this.content.objectid}`)[0].addEventListener("mouseout", () => {
          document.getElementsByClassName(`Path_13${this.content.objectid}`)[0].setAttribute("fill", "#ffffff")
        })

    } catch (e) {
      
    }
  },
  methods: {
    toggleDetailShare(state) {
      let payload = {
        popupState: state,
        content: this.content
      };
      eventBus.$emit("show-content-share", payload);
    }
  }
};
</script>

<style lang="scss">
@import "./detailIcon.scss";
@import "@/sass/_variables.scss";

// .iconouterfill{
//   fill:$like-icon-outerfill
// }

@media only screen and (min-width: 1000px) {
    #Component_9_1:hover g { 
      fill:$clr-likebutton-hover;
  }
}

</style>





